import { Component, Input, OnInit } from '@angular/core';
import { Operations } from '../../interface/company-client.interface';

@Component({
  selector: 'app-invoice-operations',
  templateUrl: './invoice-operations.component.html',
  styleUrls: ['./invoice-operations.component.scss'],
})
export class InvoiceOperationsComponent {
  @Input() operations: Operations[];
  @Input() operationsApproved: Operations[];
  @Input() rutUrl: number;
  open: boolean = true;  
  openP: boolean = false;  

  constructor() { 
    
  }

  openCreate() {
    this.open = true;   
    this.openP = false; 
  }

  openApproved() {
    this.openP = true;  
    this.open = false;  
  }
}
